<template>
    <div class="rule-tool-page" @click.capture="checkAuthentice">
        <div class="header">
            <div class="title">法规检索工具</div>
            <div class="subTitles">
                <span class="subTitle">
                    <span class="strong">百度律临 × 北大法宝</span>联合打造
                </span>
                <span class="subTitle">
                    <span class="strong">超300万部</span>法律文件收录
                </span>
                <span class="subTitle">
                    律临专属<span class="strong">5次/日</span>检索权益
                </span>
            </div>
            <veui-button
                class="button" @click="goto('top-button')"
            >专属限免，立即使用</veui-button>
        </div>
        <div class="section-1">
            <div class="title">
                <span class="index">01</span><span class="text">海量案例收录，提供有效参考</span>
            </div>
            <div class="divider"></div>
            <div class="contents">
                <div class="content">
                    自<span class="strong">1949年起至今</span>的全部法律法规收录
                </div>
                <div class="content">
                    超<span class="strong">300万+</span>规范性法律文件收录
                </div>
                <div class="content">
                    涵盖<span class="strong">中央、地方</span>法规及立法资料
                </div>
                <div class="content">
                    涵盖<span class="strong">港澳台、中外及国际条约</span>全方位内容
                </div>
            </div>
        </div>
        <div class="section-2">
            <div class="title">
                <span class="index">02</span><span class="text">精准联想、新旧对比、高效好用</span>
            </div>
            <div class="divider"></div>
            <div class="contents">
                <div class="content">
                    法宝联想深入至<span class="strong">条、款、项、目</span>，互相链接印证
                </div>
                <div class="content">
                    ‘摘要展示’、‘检索结果筛选’理清您的办案思路
                </div>
                <div class="content">
                    <span class="strong">法规新旧对比</span>，助你纵览法规变迁的前世今生
                </div>
            </div>
        </div>
        <veui-button
            class="footer-button" @click="goto('bottom-button')"
        >专属限免，立即使用</veui-button>
    </div>
</template>

<script>
import {Button} from 'veui';
import {transBDFBUrl} from '@/utils/law/toolUrl.js';
import mixinauthentice from '@/mixins/authentice';
/**
 * @author xingminghua
 * @desc 案例检索
 */

export default {
    name: 'ruletool',
    mixins: [mixinauthentice],
    components: {
        'veui-button': Button
    },
    methods: {
        goto(area) {
            if (area) {
                this.$wywLog.send({
                    serverId: 16840,
                    page: 'rule-tool',
                    action: 'click',
                    area
                });
            }
            const url = transBDFBUrl({menu: 'law'});
            window.open(url);
        }
    }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/rule-case-tool.less";

.rule-tool-page {
    .tool-page();
    .header {
        background-image: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/rule-case-tool/rule-header-bg.png);
    }
    .section-1,
    .section-2 {
        .tool-page .section();
        background-repeat: no-repeat, no-repeat;
        background-position: center right, center;
        background-size: auto 100%, cover;
    }
    .section-1 {
        background-image: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/rule-case-tool/rule-content-bg-1.png),
            url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/rule-case-tool/pattern.png);
    }
    .section-2 {
        background-image: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/rule-case-tool/rule-content-bg-2.png),
            url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/rule-case-tool/pattern.png);
    }
}
</style>
